import React from "react";
import styles from "./styles.css";

const RequiredIndicator = () => <span className={styles.requiredIndicator}>*</span>;

export default RequiredIndicator;